import PaymentCrisis from "./PaymentCrisis";
export default PaymentCrisis;
